import { render, staticRenderFns } from "./GrilletarifairesShow.vue?vue&type=template&id=4fe5f76c&"
import script from "./GrilletarifairesShow.vue?vue&type=script&lang=js&"
export * from "./GrilletarifairesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports